import theme from '../../themes/theme';

const {
  Layout: { content_color, header_color },
} = theme;

export default {
  header_language_selector: {
    marginTop: '1em',
  },
  layoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  content: {
    backgroundColor: content_color,
    display: 'flex',
    flexDirection: 'column',
    order: 0,
    flex: 12,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
  },

  footer: {
    backgroundColor: content_color,
    order: 0,
    flex: 1,
    alignSelf: 'stretch',
    fontSize: 'calc(10px + 2vmin)',
    color: header_color,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
};
